
import { apiService } from "@services/api.service";
import { useLoader } from "@composables/loader";
import { defineComponent, onMounted, ref, Ref, watch } from "vue";
import CiContentHubTile from "@components/content_hubs/tile.vue";
import { useRoute } from "vue-router/composables";

export default defineComponent({
  name: "CiRelatedContentHubs",
  components: {
    CiContentHubTile,
  },
  setup() {
    const route = useRoute();
    const loader = useLoader();
    const contentRoutes: Ref<ContentHubs.ContentRoute[]> = ref([]);

    const getRelatedContentRoutes = async (slug: string): Promise<void> => {
      loader.start();
      try {
        const response = await apiService.contentHubs.getRelatedContentRoutes(slug);
        contentRoutes.value = response.data.content_routes;
      } catch (error) {
        apiService.handleAPIError(error);
      } finally {
        loader.stop();
      }
    };

    onMounted(() => getRelatedContentRoutes(route.params.pathMatch));

    watch(
      () => route.params.pathMatch,
      async (newSlug) => getRelatedContentRoutes(newSlug)
    );

    return { contentRoutes };
  },
});
